export const APP_BANNER_LOGO =
  'https://caterpillar.scene7.com/is/image/Caterpillar/CM20220802-6f5b0-875c2?wid=40&hei=40';

export const ANDROID_APP_URI_SCHEME =
  'com.cat.digital.ecomm://home?app-argument=';
export const ANDROID_INSTALL_URL =
  'https://parts.cat.com/en/catcorp/app-download?utm_content=catcentral_install&utm_source=smart_banner&utm_medium=mobile_web&utm_campaign=';

export const COOKIE_EXPIRATION_DAYS = 7;

export const SKIP_MOBILE_APP_ADVERT_BANNER_COOKIE = 'skipMobileAppAdvertBanner';
